<div class="slider">
  <splide [options]="sliderOptions" class="slider slider--pink">
    <splide-slide>
      <div class="slider__item pb-10">
        <div class="slider__img">
          <img src="/images/tutorial/game/slides/big-quick-live/slide1.jpg" alt="Slide 1" class="m-auto">
        </div>
        <div class="slider__desc">
          Your <strong>15 coins</strong> relate to <strong>15 things</strong> that can happen in the match. Tap on a coin to see what it is.
        </div>
      </div>
    </splide-slide>
    <splide-slide>
      <div class="slider__item pb-10">
        <div class="slider__img">
          <img src="/images/tutorial/game/slides/big-quick-live/slide2.jpg" alt="Slide 2">
        </div>
        <div class="slider__desc">
          6 have to happen for Team A, 6 for Team B, and 3 (in the middle) are mutual.
        </div>
      </div>
    </splide-slide>
    <splide-slide>
      <div class="slider__item pb-10">
        <div class="slider__img">
          <img src="/images/tutorial/game/slides/big-quick-live/slide3.jpg" alt="Slide 3">
        </div>
        <div class="slider__desc">
          If an event happens that you have on your card, that coin turns purple.
        </div>
      </div>
    </splide-slide>
    <splide-slide>
      <div class="slider__item pb-10">
        <div class="slider__img">
          <img src="/images/tutorial/game/slides/big-quick-live/slide4.jpg" alt="Slide 4">
        </div>
        <div class="slider__desc">
          If you’re <strong>first to get 1 and/or 2 Lines</strong>, you <strong>win a prize.</strong>
        </div>
      </div>
    </splide-slide>
    <splide-slide>
      <div class="slider__item pb-10">
        <div class="slider__img">
          <img src="/images/tutorial/game/slides/big-quick-live/slide5.jpg" alt="Slide 5">
        </div>
        <div class="slider__desc">
          If <strong>all your 15 events happen first</strong> in the match, you <strong>get a Full House</strong>, <br /> and you <strong>win the main prizepot.</strong>
        </div>
      </div>
    </splide-slide>
  </splide>
</div>
